import { render, staticRenderFns } from "./BillVatInfo.vue?vue&type=template&id=0fca3bec&"
import script from "./BillVatInfo.vue?vue&type=script&lang=js&"
export * from "./BillVatInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports